import { render, staticRenderFns } from "./SubmissionCreateChoiceModal.vue?vue&type=template&id=4eda050b&scoped=true"
import script from "./SubmissionCreateChoiceModal.vue?vue&type=script&lang=js"
export * from "./SubmissionCreateChoiceModal.vue?vue&type=script&lang=js"
import style0 from "./SubmissionCreateChoiceModal.vue?vue&type=style&index=0&id=4eda050b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eda050b",
  null
  
)

export default component.exports